import api from '@/lib/api-client';
import type { TaskDeliverable } from '@/types/api';

export const taskDeliverableService = {
  create: async (taskId: string, payload: { title: string; orderIndex?: number }): Promise<TaskDeliverable> => {
    const { data } = await api.post<TaskDeliverable>(`/projects/project-tasks/${taskId}/deliverables`, payload);
    return data;
  },

  update: async (id: string, payload: { title?: string; done?: boolean }): Promise<TaskDeliverable> => {
    const { data } = await api.patch<TaskDeliverable>(`/projects/project-tasks/deliverables/${id}`, payload);
    return data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/projects/project-tasks/deliverables/${id}`);
  },
};
